
const QuestionType = {
    BodyMembers: "bodyMembers",
    Simple: "simple",
    Comorbidities: "comorbidities",
    Activities: "activities"
}

export default QuestionType